/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type InvoiceList_storeLists$ref: FragmentReference;
declare export opaque type InvoiceList_storeLists$fragmentType: InvoiceList_storeLists$ref;
export type InvoiceList_storeLists = {|
  +id: string,
  +invoices: $ReadOnlyArray<{|
    +id: string,
    +startDate: string,
    +endDate: string,
    +amountDue: number,
    +state: string,
    +invoiceNumber: number,
    +invoicePdfUrl: string,
  |}>,
  +$refType: InvoiceList_storeLists$ref,
|};
export type InvoiceList_storeLists$data = InvoiceList_storeLists;
export type InvoiceList_storeLists$key = {
  +$data?: InvoiceList_storeLists$data,
  +$fragmentRefs: InvoiceList_storeLists$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "storeId",
      "type": "ID!"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "InvoiceList_storeLists",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "storeId",
          "variableName": "storeId"
        }
      ],
      "concreteType": "Invoice",
      "kind": "LinkedField",
      "name": "invoices",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "amountDue",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "state",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "invoiceNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "invoicePdfUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StoreLists"
};
})();
// prettier-ignore
(node/*: any*/).hash = '0cd089f843224ee6cec5e248d39549b2';

module.exports = node;
